import React, { useState, useEffect, useRef } from 'react'
import { NavLink, useHistory, useParams } from 'react-router-dom'
import { Game10Map, getRndFromArray, useStore, GameStatus, shuffleArray } from '../lib'
import { Guide, Image as Img, Loader, ModalAlert, ModalImage, ScoreStats, SideNav } from '../components'
import { GameFrame } from './GameFrame'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

export const Game10 = () => {
  const [isInitialized, setIsInitialized] = useState<boolean>(false)
  const [isFinished, setIsFinished] = useState<boolean>(false)
  const [imgWidth, setImgWidth] = useState<number>((window.innerWidth * 0.6) / 3)
  const [steps, setSteps] = useState<any[]>([])
  const [sortedSteps, setSortedSteps] = useState<any[]>([])
  const [status, setStatus] = useState<{ [key: string]: GameStatus }>({})
  const [gameStartTime, setGameStartTime] = useState<number>(+new Date())
  const [gameEndTime, setGameEndTime] = useState<number>()
  const history = useHistory()
  const refModalAlert: any = useRef(null)
  const refModalImage: any = useRef(null)
  const refGuide: any = useRef(null)
  // const { id }: any = useParams()
  const { state, patchState } = useStore()

  const preloadImages = async () => {
    const onImgLoad = async (imageEl: HTMLImageElement) => {
      return new Promise(resolve => {
        imageEl.onload = () => resolve(imageEl)
      })
    }
    const allItems = getRndFromArray([...Game10Map.items], 9)
    const all = allItems.map((a: any) => a.img)
    for (const imgSrc of all) {
      const img = new Image()
      img.src = imgSrc
      await onImgLoad(img)
    }
    setSteps(shuffleArray(allItems))
    // setSortedSteps(shuffleArray(allItems))
    setIsInitialized(true)
    // refModalAlert?.current?.openModal(Game10Map.intro)
    refGuide?.current?.openModal(Game10Map.intro)
    refGuide?.current?.speak()
    return true
  }

  useEffect(() => {
    if (!isInitialized) {
      preloadImages()
      patchState({ score: 0, errors: 0 }) // todo
    }
  }, [isInitialized])

  const onSelect = (step: any) => {
    if (sortedSteps.length === step.id) {
      setSteps(steps.filter(s => s.id !== step.id))
      const nextSortedSteps = [...sortedSteps, step]
      setSortedSteps(nextSortedSteps)
      patchState({ score: state.score + 1 })
      refGuide?.current?.openModal([step.comment])
      if (nextSortedSteps.length === 9) {
        const timeMs = +new Date() - gameStartTime
        patchState({
          timeMs: state.timeMs + timeMs,
          games: { ...state.games, game10: { score: state.score, errors: state.errors, timeMs } },
        })
        setGameEndTime(+new Date())
        refGuide.current?.playSound()
        refGuide?.current?.onGameEnd(state.errors)
        setIsFinished(true)
      }
    } else {
      patchState({ errors: state.errors + 1 })
      setStatus({ ...status, ...{ [step.id]: 'error' } })
      const t = setTimeout(() => setStatus({ ...status, ...{ [step.id]: null } }), 500)
    }
  }

  const showDetail = (step: any) => {
    refModalImage?.current?.openModal(step?.img)
  }

  const exitGame = () => {
    setSteps([])
    setIsInitialized(false)
    setTimeout(() => history.push('/dashboard'))
  }

  if (!isInitialized || !steps) {
    return <Loader />
  }

  // const missingSteps = new Array(steps.length - sortedSteps.length)
  //
  // console.warn({missingSteps}); // TODO: remove
  // console.warn([...(Game10Map.items.filter(a => steps.filter(b => a.id === b.id).length > 0))]); // TODO: remove
  return (
    <div className="view background-summer">
      <div className="view-content p-5 text-black">
        <h1 className="text-3xl text-center font-bold w-full">Od semínka po výrobek</h1>
        <ScoreStats
          isCompact={true}
          isTimeShown={true}
          startTime={gameStartTime}
          endTime={gameEndTime}
          customScore={state.score}
          customErrors={state.errors}
        />
        <SideNav customScore={state.score} customErrors={state.errors} customText={Game10Map.intro} />
        <Guide ref={refGuide} isWinter={false} hasWinterGearA={true} hasWinterGearB={true} />
        <GameFrame
          isFinished={isFinished}
          isWhiteBg={true}
          onExit={exitGame}
          childrenLeft={steps.map(step => (
            <div
              className="w-1/3 h-1/3 flex flex-col justify-center items-center overflow-hidden cursor-pointer"
              key={step.id}
            >
              <Img
                src={step.img}
                title={step.label}
                width={`${imgWidth}px`}
                // width={`100%`}
                scale={1}
                padding={'1rem'}
                hasError={status[step.id] === 'error'}
                onClick={() => onSelect(step)}
                onLabelClick={() => onSelect(step)}
              />
            </div>
          ))}
          childrenRight={
            <ul className="steps steps-vertical">
              {/*{sortedSteps.length === 0 && (*/}
              {/*    <div className="card glass w-1/2 p-2 font-bold">*/}
              {/*      Najdi semínko!*/}
              {/*    </div>*/}
              {/*)}*/}
              {sortedSteps.map(step => (
                <li
                  className="step step-primary"
                  key={`sorted-${step.id}`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => showDetail(step)}
                >
                  <div className="glass shadow-xl p-2 rounded-2xl font-bold">{step.label}</div>
                </li>
              ))}
              {/*{Array(steps.length - sortedSteps.length).map((_, i) => (*/}
              {/*{[...(Game10Map.items.filter(a => steps.filter(b => a.id === b.id).length > 0))].map((_, i) => (*/}
              {/*    <li className="step" key={`sorted-placeholder-${i}`}>...</li>*/}
              {/*))}*/}
            </ul>
          }
        />
        <div>
          <ModalAlert ref={refModalAlert} />
        </div>
        <div>
          <ModalImage ref={refModalImage} />
        </div>
      </div>
    </div>
  )
}
